import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface MobilePageTitleContextType {
  title: string;
  setTitle: (title: string) => void;
  backPath: string | null;
  setBackPath: (path: string | null) => void;
}

const MobilePageTitleContext = createContext<MobilePageTitleContextType>({
  title: '',
  setTitle: () => {},
  backPath: null,
  setBackPath: () => {},
});

export const MobilePageTitleProvider = ({ children }: { children: ReactNode }) => {
  const [title, setTitle] = useState('');
  const [backPath, setBackPath] = useState<string | null>(null);

  return (
    <MobilePageTitleContext.Provider value={{ title, setTitle, backPath, setBackPath }}>
      {children}
    </MobilePageTitleContext.Provider>
  );
};

/** Read the current mobile page title */
export const useMobilePageTitle = () => useContext(MobilePageTitleContext).title;

/** Read the current back path (null = no back button) */
export const useMobileBackPath = () => useContext(MobilePageTitleContext).backPath;

/** Set the mobile page title (call from PageTitle or page components) */
export const useSetMobilePageTitle = (title: string) => {
  const { setTitle } = useContext(MobilePageTitleContext);
  useEffect(() => {
    if (title) setTitle(title);
  }, [title, setTitle]);
};

/** Set a back path to show a back arrow in the mobile top bar */
export const useSetMobileBackPath = (path: string) => {
  const { setBackPath } = useContext(MobilePageTitleContext);
  useEffect(() => {
    setBackPath(path);
    return () => setBackPath(null);
  }, [path, setBackPath]);
};
